import React from 'react';
import loadable from '@loadable/component';

const LoadableComponent = loadable(() =>
  import(/* webpackChunkName: "graph" */ './median-price')
);

const MedianPriceLoader = props => <LoadableComponent {...props} />;

export default MedianPriceLoader;
